module.exports = __webpack_public_path__ + "img/keepy_uppy_card.59bdd243.svg";